
import { Editor, EditorContent, BubbleMenu, FloatingMenu } from "@tiptap/vue-2"
import Table from "@tiptap/extension-table"
import TableRow from "@tiptap/extension-table-row"
import TableCell from "@tiptap/extension-table-cell"
import TableHeader from "@tiptap/extension-table-header"
import Link from "@tiptap/extension-link"
import StarterKit from "@tiptap/starter-kit"
export default {
	data() {
		return {
			editor: null,
			contentHeight: 0,
		}
	},
	beforeUnmount() {
		this.editor.destroy()
	},
	mounted() {
		this.editor = new Editor({
			content: this.context.model,
			extensions: [
				StarterKit,
				Table.configure({
					resizable: true,
				}),
				TableRow,
				TableHeader,
				TableCell,
				Link.configure({
					protocols: ["mailto"],
				}),
			],
			onUpdate: () => {
				// HTML
				this.context.model = this.editor.getHTML()

				// Update content height
				this.$nextTick(() => {
					this.updateContentHeight()
				})

				// JSON
				// this.$emit('input', this.editor.getJSON())
			},
		})

		// Initial height measurement
		this.$nextTick(() => {
			this.updateContentHeight()
		})
	},
	components: {
		EditorContent,
		BubbleMenu,
		FloatingMenu,
	},
	computed: {
		model() {
			return this.context.model
		},
		heightLimitEnabled() {
			return this.maxHeight !== null && this.maxHeight > 0
		},
		maxContentHeight() {
			return this.maxHeight || 750 // Default to 750px for 1 PDF page
		},
		heightWarningThreshold() {
			return this.maxContentHeight * 0.9 // 90% threshold
		},
		isAtHeightLimit() {
			if (!this.heightLimitEnabled) return false
			return this.contentHeight >= this.maxContentHeight
		},
		isNearHeightLimit() {
			if (!this.heightLimitEnabled) return false
			return this.contentHeight >= this.heightWarningThreshold && !this.isAtHeightLimit
		},
		heightPercentage() {
			if (!this.heightLimitEnabled) return 0
			return Math.min(100, (this.contentHeight / this.maxContentHeight) * 100)
		},
		editorStateClass() {
			if (!this.heightLimitEnabled) return ""
			if (this.isAtHeightLimit) return "danger"
			if (this.isNearHeightLimit) return "warning"
			return ""
		},
		heightWarningMessage() {
			if (this.isAtHeightLimit) {
				return "Content may not fit on PDF page due to text wrapping. Consider adding a new page."
			}
			if (this.isNearHeightLimit) {
				return "Content approaching page limit and may not fit due to text wrapping"
			}
			return ""
		},
	},
	methods: {
		updateContentHeight() {
			if (!this.heightLimitEnabled) return
			const editorElement = this.$el?.querySelector(".ProseMirror")
			if (editorElement) {
				this.contentHeight = editorElement.scrollHeight
			}
		},
		setLink() {
			const previousUrl = this.editor.getAttributes("link").href
			const url = window.prompt("URL", previousUrl)

			// cancelled
			if (url === null) {
				return
			}

			// empty
			if (url === "") {
				this.editor.chain().focus().extendMarkRange("link").unsetLink().run()

				return
			}

			// update link
			this.editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run()
		},
	},
	watch: {
		// Watches the computed model (there is no value prop), so a value set from outside the editor,
		// such as a template or a prefill, reaches it. The editor's own updates compare as the same.
		model(value) {
			// HTML
			const isSame = this.editor.getHTML() === value

			// JSON
			// const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

			if (isSame) {
				return
			}

			this.editor.commands.setContent(value, false)
		},
	},
	props: {
		context: {
			type: Object,
			required: true,
		},
		toolbar: {
			type: Boolean,
			default: true,
		},
		value: {
			type: String,
			default: "",
		},
		maxHeight: {
			type: Number,
			default: null, // null = no height limit (opt-in feature)
		},
	},
}
